import { createRouter, createWebHistory } from 'vue-router'
import AppLayout from '@/views/layout/AppLayout.vue'
import { useUserStore } from '@/stores/userStore'
import client from '@/router/modules/client'
import company from '@/router/modules/company'
import auth from '@/router/modules/auth'
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    if (savedPosition) return savedPosition
    return { top: 0 }
  },
  routes: [{ path: '/', component: AppLayout, children: [...client, ...company] }, ...auth],
})
// Navigation guard for authentication and role-based access
router.beforeEach(async (to, from, next) => {
  try {
    const userStore = useUserStore()
    const isAuthenticated = !!userStore.role // If user has a role, they are authenticated
    const userRole = userStore.role

    console.log(`Navigating to: ${to.fullPath}, Role: ${userRole}`)

    // Redirect to sign-in if authentication is required but the user is not logged in
    if (to.meta.requiresAuth && !isAuthenticated) {
      return next({ name: 'signin' })
    }

    // Allow admins to access admin routes
    if (to.meta.requiresAdmin) {
      if (
        userRole === 'company_user' ||
        userRole == 'company_admin' ||
        userRole == 'company_suadmin' ||
        userRole == 'company_owner'
      ) {
        return next() // Allow access
      } else {
        console.log('---------')
        return next({ name: 'AccountSettingsMain' }) // Redirect non-admins
      }
    }

    // Allow only superadmin and owner to access superadmin routes
    if (to.meta.requiresSuperAdmin) {
      if (userRole === 'company_suadmin' || userRole === 'company_owner') {
        return next() // Allow access
      } else {
        console.log('Access denied: Requires Super Admin or Owner role')
        return next({ name: 'AccountSettingsMain' }) // Redirect non-superadmins
      }
    }

    next()
  } catch (error) {
    console.error('Navigation error:', error)
    // return next({ name: 'signin' });
  }
})
export default router
